/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_BlogInputs */

const et_nav_blog = /** @type {(inputs: Nav_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blogi`)
};

const en_nav_blog = /** @type {(inputs: Nav_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog`)
};

/**
* | output |
* | --- |
* | "Blog" |
*
* @param {Nav_BlogInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_blog = /** @type {((inputs?: Nav_BlogInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_BlogInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_nav_blog(inputs)
	return en_nav_blog(inputs)
});